export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-white">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-3xl bg-primary-500 flex items-center justify-center">
              <div className="text-center text-white">
                <div className="text-4xl md:text-5xl font-heading font-bold mb-1">91</div>
                <div className="text-sm md:text-base font-medium tracking-widest">精品影视</div>
                <div className="mt-3 w-10 h-0.5 bg-white/40 mx-auto"></div>
                <div className="text-xs mt-2 text-white/60">since 2019</div>
              </div>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              关于91精品影视
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              91精品影视创立于2019年，是一家专注于移动端影视内容分发与观看体验优化的科技公司。我们致力于为广大影视爱好者提供便捷、流畅、高清的移动观影解决方案。经过多年的产品打磨与技术沉淀，91精品影视APP已累计服务超过千万用户，成为国内领先的移动影视平台之一。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们的内容团队与国内外多家内容提供商建立了深度合作关系，确保片库的丰富性与时效性。从院线大片到热播剧集，从经典老片到独家内容，91精品影视始终保持每日更新节奏，让用户第一时间获取最新最热的影视资源。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              未来，91精品影视将继续加大在AI推荐、超高清播放和跨端体验方面的技术投入，打造更加智能化、个性化的观影服务。我们相信，好的影视内容值得被更好地呈现。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}